import { NavLink, Navigate, Outlet, useNavigate } from "react-router-dom";
import { LayoutDashboard, Building2, Users, LifeBuoy, Handshake, Settings, ScrollText, LogOut, ArrowLeftRight } from "lucide-react";
import { useApp } from "../context/AppContext";

const NAV = [["/admin", LayoutDashboard, "Tableau de bord", "dashboard"], ["/admin/comptes", Building2, "Comptes et équipes", "accounts"],
  ["/admin/utilisateurs", Users, "Utilisateurs", "users"], ["/admin/assistance", LifeBuoy, "Assistance", "support"],
  ["/admin/suivi", Handshake, "Suivi AVELIS", "crm"], ["/admin/parametres", Settings, "Paramètres", "settings"],
  ["/admin/journal", ScrollText, "Journal d'activité", "audit"]];

function Item({ to, Icon, label, id }) {
  return (
    <NavLink end={to === "/admin"} to={to} data-testid={`admin-nav-${id}`}
      className={({ isActive }) => `flex shrink-0 items-center gap-2.5 rounded-xl px-3 py-2.5 text-sm font-semibold transition-colors ${isActive ? "bg-white/15 text-white" : "text-white/70 hover:bg-white/10 hover:text-white"}`}>
      <Icon className="h-4 w-4" />{label}
    </NavLink>
  );
}

export function AdminShell() {
  const { user, structures, logout } = useApp();
  const nav = useNavigate();
  if (!user?.is_superadmin) return <Navigate to="/" replace />;
  const own = structures.filter((s) => !s.support);
  const out = async () => { await logout(); nav("/login"); };
  return (
    <div className="min-h-screen bg-slate-50 lg:flex" data-testid="admin-shell">
      <aside className="pt-safe sticky top-0 z-40 bg-[#132F3A] text-white lg:h-screen lg:w-64 lg:shrink-0">
        <div className="flex items-center justify-between gap-2 px-4 py-3 lg:block lg:px-5 lg:py-6">
          <div><div className="text-lg font-bold tracking-wide">AVELIS</div><div className="text-[11px] font-semibold uppercase tracking-[0.18em] text-[#A5BAA5]">Administration</div></div>
          <div className="flex gap-1 lg:hidden">
            {own.length > 0 && <button onClick={() => nav("/")} className="rounded-lg p-2 text-white/80" aria-label="Mon espace équipe" data-testid="admin-own-space-btn-mobile"><ArrowLeftRight className="h-5 w-5" /></button>}
            <button onClick={out} className="rounded-lg p-2 text-white/80" aria-label="Déconnexion" data-testid="admin-logout-btn-mobile"><LogOut className="h-5 w-5" /></button>
          </div>
        </div>
        <nav className="flex gap-1 overflow-x-auto px-3 pb-3 lg:flex-col lg:px-3">
          {NAV.map(([to, Icon, label, id]) => <Item key={to} to={to} Icon={Icon} label={label} id={id} />)}
        </nav>
        <div className="hidden px-3 lg:absolute lg:bottom-4 lg:block lg:w-64">
          {own.length > 0 && <button onClick={() => nav("/")} className="flex w-full items-center gap-2.5 rounded-xl px-3 py-2.5 text-sm font-semibold text-white/70 hover:bg-white/10" data-testid="admin-own-space-btn"><ArrowLeftRight className="h-4 w-4" />Mon espace équipe</button>}
          <button onClick={out} className="flex w-full items-center gap-2.5 rounded-xl px-3 py-2.5 text-sm font-semibold text-white/70 hover:bg-white/10" data-testid="admin-logout-btn"><LogOut className="h-4 w-4" />Déconnexion</button>
          <div className="truncate px-3 pt-2 text-xs text-white/50">{user.email}</div>
        </div>
      </aside>
      <main className="mx-auto w-full max-w-6xl px-4 py-6 lg:px-10 lg:py-10"><Outlet /></main>
    </div>
  );
}
